import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { useAuth } from "../Components/AuthContext";
import { logoutUser } from "../Components/Authservice.ts";
import "../App.css";

// Layout component integrated into About page
const About = () => {
  const { user } = useAuth();
  
  return (
    <>
      {/* Navigation Header */}
      <header className="navbar">
        <div className="logo">Ani<span className="highlight">Spark</span></div>
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/explore">Explore</Link>
          <Link to="/upload">Upload</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        
        <div className="auth-buttons">
          {user ? (
            <>
              <span className="welcome-text">Welcome, {user.email}</span>
              <button onClick={logoutUser} className="login">Log Out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="auth-button login">Login</Link>
              <Link to="/signup" className="auth-button signup">Sign Up</Link>
            </>
          )}
        </div>
      </header>

      {/* About Page Content */}
      <div className="explore-page" style={{ minHeight: "100vh" }}>
        <div className="star-field">
          {Array.from({ length: 100 }).map((_, i) => (
            <div
              key={i}
              className="star"
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`
              }}
            />
          ))}
        </div>

        <Container fluid className="py-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={8}>
              <div className="text-center mb-5">
                <img 
                  src="/sparkyhappy.png"
                  alt="AniSpark Mascot" 
                  className="mascot-image mb-4"
                  style={{
                    width: '120px',
                    height: '120px',
                    filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.3))'
                  }}
                />
                <h1 className="text-light mb-3" style={{ fontSize: '3rem', fontWeight: '700' }}>
                  About AniSpark
                </h1>
                <p className="text-light" style={{ fontSize: '1.2rem', opacity: 0.9 }}>
                  Empowering independent animators, one spark at a time
                </p>
              </div>

              <Row className="g-4">
                <Col md={12}>
                  <Card 
                    className="mb-4"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-5">
                      <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '2rem', fontWeight: '600' }}>
                        Our Mission
                      </h2>
                      <p className="text-light" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                        AniSpark is dedicated to empowering independent animators by providing a platform 
                        where creativity meets community. We believe that every animator, regardless of 
                        their background or resources, deserves a space to showcase their work and connect 
                        with audiences who appreciate the art of animation.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card 
                    className="mb-4 h-100"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-4">
                      <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                        What We Offer
                      </h3>
                      <ul className="text-light" style={{ fontSize: '1rem', lineHeight: '1.6', opacity: 0.9 }}>
                        <li className="mb-2">🎨 <strong>Creative Showcase:</strong> Display your animations to a global audience</li>
                        <li className="mb-2">🤝 <strong>Community Connection:</strong> Network with fellow animators and enthusiasts</li>
                        <li className="mb-2">📚 <strong>Learning Resources:</strong> Access tutorials and industry insights</li>
                        <li className="mb-2">💡 <strong>Feedback & Collaboration:</strong> Get constructive feedback and find collaborators</li>
                        <li className="mb-2">🌟 <strong>Recognition:</strong> Get featured and gain visibility for your work</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card 
                    className="mb-4 h-100"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-4">
                      <h3 className="text-light mb-3" style={{ color: '#facc15', fontSize: '1.5rem', fontWeight: '600' }}>
                        Our Values
                      </h3>
                      <div className="text-light" style={{ fontSize: '1rem', lineHeight: '1.6', opacity: 0.9 }}>
                        <p className="mb-3">
                          <strong>Creativity First:</strong> We celebrate original thinking and artistic expression in all its forms.
                        </p>
                        <p className="mb-3">
                          <strong>Inclusive Community:</strong> Everyone is welcome, regardless of skill level or background.
                        </p>
                        <p className="mb-3">
                          <strong>Quality Focus:</strong> We maintain high standards while supporting growth and learning.
                        </p>
                        <p className="mb-0">
                          <strong>Artist Support:</strong> Your success is our success. We're here to help you thrive.
                        </p>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={12}>
                  <Card 
                    className="mb-4"
                    style={{ 
                      backgroundColor: "rgba(30, 27, 75, 0.8)", 
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      borderRadius: "16px",
                      backdropFilter: "blur(10px)"
                    }}
                  >
                    <Card.Body className="p-5">
                      <h2 className="text-light mb-4" style={{ color: '#facc15', fontSize: '2rem', fontWeight: '600' }}>
                        Join Our Community
                      </h2>
                      <p className="text-light mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8', opacity: 0.9 }}>
                        Whether you're a seasoned professional or just starting your animation journey, AniSpark 
                        is your home for creative expression. Upload your work, discover amazing content from 
                        other creators, and become part of a community that celebrates the magic of animation.
                      </p>
                      <div className="d-flex gap-3 flex-wrap">
                        <Link to="/signup" className="btn btn-primary px-4 py-2" style={{ background: '#facc15', border: 'none', color: '#1e1b4b', fontWeight: '600' }}>
                          Get Started
                        </Link>
                        <Link to="/explore" className="btn btn-outline-light px-4 py-2">
                          Explore Content
                        </Link>
                        <Link to="/contact" className="btn btn-outline-light px-4 py-2">
                          Contact Us
                        </Link>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>

        <style jsx>{`
          /* Navigation Styles */
          .navbar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1rem 2rem;
            background: rgba(30, 27, 75, 0.9);
            backdrop-filter: blur(10px);
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            position: sticky;
            top: 0;
            z-index: 1000;
          }

          .logo {
            font-size: 1.8rem;
            font-weight: 700;
            color: white;
          }

          .highlight {
            color: #facc15;
          }

          .nav-links {
            display: flex;
            gap: 2rem;
          }

          .nav-links a {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: color 0.3s ease;
          }

          .nav-links a:hover {
            color: #facc15;
          }

          .auth-buttons {
            display: flex;
            gap: 1rem;
            align-items: center;
          }

          .welcome-text {
            color: white;
            margin-right: 1rem;
          }

          .auth-button, .login {
            padding: 0.5rem 1rem;
            border-radius: 8px;
            text-decoration: none;
            font-weight: 500;
            transition: all 0.3s ease;
            border: none;
            cursor: pointer;
          }

          .login {
            background: transparent;
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.3);
          }

          .login:hover {
            background: rgba(255, 255, 255, 0.1);
          }

          .signup {
            background: #facc15;
            color: #1e1b4b;
          }

          .signup:hover {
            background: #eab308;
          }

          /* Existing page styles */
          .explore-page {
            background: linear-gradient(135deg, #1e1b4b 0%, #3c366b 100%);
            position: relative;
            overflow: hidden;
          }
          
          .star-field {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 1;
          }
          
          .container-fluid {
            position: relative;
            z-index: 2;
          }

          .star {
            position: absolute;
            width: 2px;
            height: 2px;
            background: white;
            border-radius: 50%;
            animation: twinkle 3s ease-in-out infinite;
          }
          
          @keyframes twinkle {
            0%, 100% { opacity: 0.3; }
            50% { opacity: 1; }
          }

          .card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .card:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          }

          .mascot-image {
            animation: float 3s ease-in-out infinite;
          }

          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }

          /* Button Styles */
          .btn {
            transition: all 0.3s ease;
            text-decoration: none;
            display: inline-block;
            text-align: center;
            border-radius: 8px;
            font-weight: 500;
          }

          .btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .navbar {
              flex-direction: column;
              gap: 1rem;
              padding: 1rem;
            }
            
            .nav-links {
              gap: 1rem;
            }
            
            .auth-buttons {
              flex-direction: column;
              gap: 0.5rem;
            }

            h1 {
              font-size: 2rem !important;
            }

            .d-flex {
              justify-content: center;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default About;